import { AttachAddon } from '@xterm/addon-attach';

class PodExecTerminalAttachAddon extends AttachAddon {
  #textEncoder = new TextEncoder();
  constructor(socket, options) {
    super(socket, options);
    const thisAddon = this;
    thisAddon._sendBinary = (data) => {
      if (!thisAddon._checkOpenSocket()) {
        return;
      }
      const buffer = Uint8Array.from([0, ...this.#textEncoder.encode(data)]);
      thisAddon._socket.send(buffer);
    };
    thisAddon._sendData = (data) => {
      if (!thisAddon._checkOpenSocket()) {
        return;
      }
      thisAddon._sendBinary(data);
    };
  }
}

export { PodExecTerminalAttachAddon };
//# sourceMappingURL=PodExecTerminalAttachAddon.esm.js.map
